import { useState } from "react";
import AlertsComp from './AlertsComp';
import ReactDatePicker from "react-datepicker";

export default function CustomReactDatePicker({ isRequired = "false", inputName, selectedDate, onChangeHandler, minDate, maxDate, placeholderText = "MM-DD-YYYY", isDisabled, isReadOnly, showTimeSelect = false, minTime, maxTime }) {
    const [Alerts, setAlerts] = useState(null);

    const isSelectedToday = !selectedDate || new Date(selectedDate).toDateString() === new Date().toDateString();

    const effectiveMinTime = showTimeSelect && isSelectedToday ? minTime : undefined;
    const effectiveMaxTime = showTimeSelect && isSelectedToday ? maxTime : undefined;

    const handleRawInput = (e) => {
        const inputLimit = showTimeSelect ? 20 : 10
        if (e.target.value?.length > inputLimit) {
            e.preventDefault();
            return
        }
    }

    const handleBlur = (e) => {
        let val = e.target.value?.trim();
        if (!val) return;
        val = val?.replaceAll("/", "-");
        let datePart = val;
        let timePart = null;

        if (showTimeSelect && val?.includes(" ")) {
            [datePart, timePart] = val?.split(" ");
        }

        //For Use Cases like 1/7/2026, 1-7-206, 1-07-2026, 01-7-2026
        let parts = datePart?.split("-");
        if (parts.length === 3) {
            let [m, d, y] = parts;
            if (y.length == 4) {
                datePart = `${m.padStart(2, "0")}-${d.padStart(2, "0")}-${y}`;
            }
        }

        //For valid dates without "/" or "-" and length 6 like 172026, 242026, etc.
        if (/^\d{6}$/.test(datePart)) {
            datePart = datePart.replace(/^(\d)(\d)(\d{4})$/, (match, m, d, y) => `${m.padStart(2, "0")}-${d.padStart(2, "0")}-${y}`);
        }

        //For valid dates without "/" or "-" and length 7 like 1172026, 2142026, etc
        if (/^\d{7}$/.test(datePart)) {
            datePart = datePart.replace(/^(\d)(\d{2})(\d{4})$/, (match, m, d, y) => `${m.padStart(2, "0")}-${d}-${y}`);
        }

        //For valid dates without "/" or "-" and length 8 like 11172026, 12142026, etc
        if (/^\d{8}$/.test(datePart)) {
            datePart = datePart?.replace(/(\d{2})(\d{2})(\d{4})/, "$1-$2-$3");
        }

        //Proper date length testing after conversion
        if (!/^\d{2}-\d{2}-\d{4}$/.test(datePart)) {
            showError();
            e.target.value = "";
            onChangeHandler(null);
            return;
        }

        //Date Testing. Is a valid date ?
        const [mm, dd, yyyy] = datePart?.split("-");
        const dateObj = new Date(
            Number(yyyy),
            Number(mm) - 1,
            Number(dd)
        );
        const isValid =
            dateObj.getFullYear() == Number(yyyy) &&
            dateObj.getMonth() + 1 == Number(mm) &&
            dateObj.getDate() == Number(dd);

        if (!isValid) {
            showError();
            e.target.value = "";
            onChangeHandler(null);
            return;
        }

        // Min date validation
        if (minDate) {
            const min = new Date(minDate);
            min.setHours(0, 0, 0, 0);

            const current = new Date(dateObj);
            current.setHours(0, 0, 0, 0);

            if (current < min) {
                setAlerts(
                    <AlertsComp
                        show={true}
                        msg={`Date cannot be older than ${min.toLocaleDateString("en-US")}`}
                        variant="danger"
                    />
                );

                e.target.value = "";
                onChangeHandler(null);

                setTimeout(() => setAlerts(<AlertsComp show={false} />), 2000);

                return;
            }
        }

        // Max date validation
        if (maxDate) {
            const max = new Date(maxDate);
            max.setHours(0, 0, 0, 0);

            const current = new Date(dateObj);
            current.setHours(0, 0, 0, 0);

            if (current > max) {
                setAlerts(
                    <AlertsComp
                        show={true}
                        msg={`Date cannot be greater than ${max.toLocaleDateString("en-US")}`}
                        variant="danger"
                    />
                );

                e.target.value = "";
                onChangeHandler(null);

                setTimeout(() => setAlerts(<AlertsComp show={false} />), 2000);

                return;
            }
        }
        //Time Testing. Is a valid time ?
        if (showTimeSelect && timePart) {
            if (!/^\d{2}:\d{2}:\d{2}$/.test(timePart)) {
                showError();
                e.target.value = "";
                onChangeHandler(null);
                return;
            }

            const [hhStr, minStr, secStr] = timePart.split(":");

            const hh = Number(hhStr);
            const min = Number(minStr);
            const sec = Number(secStr);

            // validate ranges
            if (hh > 23 || min > 59 || sec > 59) {
                showError();
                e.target.value = "";
                onChangeHandler(null);
                return;
            }

            dateObj.setHours(hh, min, sec);

        }
        e.target.value = val;
        onChangeHandler(dateObj);
        setAlerts(<AlertsComp show={false} />);
    };

    const showError = () => {
        setAlerts(
            <AlertsComp
                show={true}
                msg="Please enter a valid date in MM-DD-YYYY format."
                variant="danger"
            />
        );
        setTimeout(() => setAlerts(<AlertsComp show={false} />), 2000);
    };
    return (
        <>
            {Alerts}
            <div className="custom-react-datepicker w-100" data-required={isRequired}>
                <ReactDatePicker
                    selected={selectedDate}
                    name={inputName}
                    onChangeRaw={handleRawInput}
                    onBlur={handleBlur}
                    onChange={onChangeHandler}
                    dateFormat={showTimeSelect ? "MM-dd-yyyy HH:mm:ss" : "MM-dd-yyyy"}
                    className="form-control"
                    autoComplete="off"
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholderText={placeholderText}
                    disabled={isDisabled}
                    readOnly={isReadOnly}
                    showTimeSelect={showTimeSelect}
                    timeIntervals={30}
                    timeFormat="HH:mm:ss"
                    minTime={effectiveMinTime}
                    maxTime={effectiveMaxTime}
                />
            </div>
        </>
    );
}